import { EventBus } from '@/main';
import { MedTransGoConstants } from './constants';
import { ApiResponse } from '@/types/response';
import { LoaderEvent, ToastEvent } from '@/types/event';
import { ObjectFactory } from '@/config/objectFactory';

// tslint:disable-next-line: no-var-requires
const errorCodes = require('../i18n/error_codes.json');
// tslint:disable-next-line: no-var-requires
const messages = require('../i18n/messages.json');
/**
 * @author <Aniket.P>
 * @description Common utils
 * @copyright Supra International, inc
 */
export class CommonUtils {

    // Decode JWT Token
    public static parseJwt(token: string) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }

    public static translateErrorCode(errorCode: any): string {
        return errorCodes[errorCode];
    }

    public static translateMessageCode(messageCode: any): string {
        return messages[messageCode];
    }

    public static showError(response: ApiResponse<any>) {
        let errorMessage = '';
        if (response.errors && response.errors.length > 0) {
            errorMessage = response.errors[0];
        } else if (response.errorCode) {
            errorMessage = CommonUtils.translateErrorCode(response.errorCode);
        }
        const toastEvent: ToastEvent = {
            message: errorMessage,
            title: 'Error!',
            timeout: 5000,
            varient: 'danger',
        };
        EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
    }

    public static isEmpty(array: any[]): boolean {
        return !(array && array.length > 0);
    }

    public static logout(config: any) {
        const toastEvent: LoaderEvent = {
            message: 'Logging out',
            show: true,
        };
        EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, toastEvent);
        ObjectFactory.getCacheService().clearCache();
        const redirectUrl = `${config.serverUrl}${MedTransGoConstants.HTTP_URL_LOGIN}/logout?clientId=${config.clientId}`;
        location.href = redirectUrl;
    }

    public static togglePassword(elementId: string, iconId: string) {
        const element = document.getElementById(elementId);
        const icon = document.getElementById(iconId);
        if (element && icon) {
            const attribute = element.attributes.getNamedItem('type');
            if (attribute && attribute.value === 'text') {
                element.setAttribute('type', 'password');
                icon.style.color = '#7a797e';
                icon.classList.add('fa-eye-slash');
                icon.classList.remove('fa-eye');
            } else {
                element.setAttribute('type', 'text');
                icon.style.color = '#5887ef';
                icon.classList.remove('fa-eye-slash');
                icon.classList.add('fa-eye');
            }
        }
    }

    public static phoneNumberMask(phoneNo: string) {
        const replaceInput = phoneNo.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        if (replaceInput && replaceInput.length) {
            return !replaceInput[2] ? replaceInput[1] :
                replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
        }
    }
}
